import { Component, OnInit, ViewChild, ElementRef, Output, EventEmitter } from '@angular/core';
import { Submission, SubmissionMethod, BusinessAddress, MailingAddress, BillingAddress, ContactObject } from '../_models/submission';
import { PRODUCT_CONFIG, SUBMISSION_MSGS, FORM_MSGS } from 'src/app/_common/product-config';
import { SubmissionsService } from '../_services/submissions.service';
import { NgForm } from '@angular/forms';
import { SUBMISSION_URL } from '../../_common/constants';
import { StatusCode, AddressType, VerifyAddressTypes, ClearAccountIndicators, SubmissionSteps, Channel, DandBEventsTypes, CustomInputType } from '../../_common/_enum/module.enum';
import { DnBEventLog } from 'src/app/_models/event-logging';

@Component({
  selector: 'app-submission-basic-info',
  templateUrl: './submission-basic-info.component.html',
  styleUrls: ['./submission-basic-info.component.scss']
})
export class SubmissionBasicInfoComponent implements OnInit {

  private submissionBasicInfo: Submission;
  private submissionData;
  private submissionMethod: SubmissionMethod = new SubmissionMethod();
  
  private loading:boolean = false;
  private existingAccountLoading:boolean = false;
  private isSubmitted: boolean = false;
  
  private submissionMsgs = SUBMISSION_MSGS; //Using it in HTML
  private submissionUrl = SUBMISSION_URL; //Using it in HTML
  private productConfig = PRODUCT_CONFIG; //Using it in HTML
  private formMsgs = FORM_MSGS; //Using it in HTML

  private addressTypes = AddressType; //Using it in HTML
  private verifyAddressTypes = VerifyAddressTypes; //Using it in HTML
  private clearAccountIndicators = ClearAccountIndicators; //Using it in HTML
  private channels = Channel; //Using it in HTML
  private customInputTypes = CustomInputType; //Using it in HTML

  private referenceData; //Using it in HTML

  private dnbEventsModel: DnBEventLog;
  private dnbEventsTypes = DandBEventsTypes;

/*   private sicCodes: any = ""; */

  private foundAddresses: any;
  private currentAddressesTypes = [];
  private accountList = [];

  @ViewChild("basicInfoForm", {static: false}) basicInfoForm: NgForm;
  @ViewChild("backToSearchModal", {static: false}) backToSearchModal;
  @ViewChild("addressValidationModal", {static: false}) addressValidationModal;
  @ViewChild("existingAccountModal", {static: false}) existingAccountModal;
  @ViewChild("clearAccountFailedModal", {static: false}) clearAccountFailedModal;
  @ViewChild('newAccountDetails', {static: false}) newAccountDetails;

  @Output() backToBusinessLookup = new EventEmitter<boolean>();

  constructor(private submissionService: SubmissionsService, private el: ElementRef) { }

  ngOnInit() {
    this.referenceData = this.submissionService.referenceData;
    this.submissionBasicInfo = this.getSubmission();
    this.submissionData = this.submissionBasicInfo.submissionData;
    this.dnbEventsModel = this.submissionService.getDnBEventData();

    this.submissionData.accountNameDisabled = this.checkIfDisabled(this.submissionData.accountName);
    this.submissionData.businessAddressDisabled = this.checkIfDisabled(this.getAddress(this.addressTypeEnum.Business));
  }

  getSubmission(){
    return this.submissionService.submission;
  }

  get addressTypeEnum(){
    return this.addressTypes;
  }

  get verifyAddressTypesEnum(){
    return this.verifyAddressTypes;
  }

  checkIfDisabled(dataElement){
    if(this.submissionData.thirdPartyName && this.submissionData.thirdPartyKey && dataElement){ return true; }
    else{ return false; }
  }

  isCompanyLegalNameInvalid(){
    if(this.submissionData && this.submissionData.accountName){
      return this.submissionData.accountName.trim().length < this.productConfig.companyNameMinLength;
    }else{
      return 0;
    }
  }

  removeHyphen(_addressType){
    if(this.getAddress(_addressType)){
      let _zip = this.getAddress(_addressType).zip;
      if(_zip.indexOf("-") == _zip.length-1){
        this.getAddress(_addressType).zip = _zip.substring(0, _zip.length-1);
      }
    }
  }

  getLegalEntity(_entityCode){
    return this.referenceData.legalEntity.find(_entity=> {return _entity.code == _entityCode});
  }

  companyEntitySelection(item1: any, item2: any){
    if(item1 && item2)
      return item1.code == item2.code;
    else
      return '';
  }

  changeCheckboxValue(_event, type){
    if(type!= ''){
      if(_event.target.checked){ //If the box is checked remove address
        if(type == this.addressTypeEnum.Mailing){
          this.submissionBasicInfo.isMailingAddressVerified = false;
          let addressIndex = this.getAddressIndex(this.addressTypeEnum.Mailing);// this.submissionData.addresses.findIndex(_address=> {return _address.addressType == this.addressTypeEnum.Mailing});

          if(addressIndex>-1)
            this.submissionData.addresses.splice(addressIndex,1);
        }else if(type == this.addressTypeEnum.Billing){
          this.submissionBasicInfo.isBillingAddressVerified = false;
          let addressIndex = this.getAddressIndex(this.addressTypeEnum.Billing);//this.submissionData.addresses.findIndex(_address=> {return _address.addressType == this.addressTypeEnum.Billing});

          if(addressIndex>-1)
            this.submissionData.addresses.splice(addressIndex,1);
        }
      }else{ //else box is unchecked, then add address
        if(type == this.addressTypeEnum.Mailing){
          this.submissionBasicInfo.isMailingAddressVerified = false;
          this.submissionData.addresses.push(new MailingAddress());
        }else if(type == this.addressTypeEnum.Billing){
          this.submissionBasicInfo.isBillingAddressVerified = false;
          this.submissionData.addresses.push(new BillingAddress());
        }
      }
    }else{
      if(!_event.target.checked){ //if the box is unchecked, add the contact
        this.submissionData.contact = new ContactObject();
      }else{//else box is unchecked, remove address
        this.submissionData.contact = {};
      }
    }
  }

  getAddress(_type){
    return this.submissionData.addresses.find(_address=> {return _address.addressType == _type});
  }
  getAddressIndex(_type){
    return this.submissionData.addresses.findIndex(_address=> {return _address.addressType == _type});
  }

  hasSICCodePercentZero(){
    let ind = this.submissionData.sicCodes.findIndex(element => {return element.percent ==0;});

    return ind > -1;
  }

  SICCodePercent(){
    let percent = 0;
    this.submissionData.sicCodes.forEach(element => {
      percent += element.percent;
    });

    return percent;
  }

  changeAddress(_address){
    if(_address.addressType == this.addressTypeEnum.Business){
      this.submissionData.addresses[0] = _address;
    }
  }

  validateAddress(addresses){
    this.loading = true;
    let addressValidationSubscription = this.submissionService.validateAddress(addresses).subscribe((data:any) => {
      this.loading = false;
      this.currentAddressesTypes = [];
      data.forEach((address, index)=>{

        address.submitted.addressType = addresses[index].addressType;
        address.submitted.careof = addresses[index].careof;
        address.submitted.verified = this.verifyAddressTypes.OVERRIDDEN;
        if(address.bestMatch){
          address.bestMatch.addressType = addresses[index].addressType;
          address.bestMatch.careof = addresses[index].careof;
          address.bestMatch.verified = this.verifyAddressTypes.VERIFIED;
          //this.submissionData.addresses[index] = address.bestMatch;
          this.currentAddressesTypes.push(address.bestMatch.verified);
        }else{
          //this.submissionData.addresses[index] = address.submitted;
          this.currentAddressesTypes.push(address.submitted.verified);
        }

      });
      this.foundAddresses = data;

      let modalClass=(addresses.length>1)?'xl':'';

      /** Opens Address Validation Modal **/
      this.submissionService.openModal('none', this.addressValidationModal, false, 'light-blue-backdrop', 'static' , 'submission-address-validation-modal', modalClass);
    },
    error => {
      this.loading = false;
      console.log("Address Validation Failed");
    });

    this.submissionService.runningServices.push(addressValidationSubscription);
  }

  updateAddress(_currentAddressesTypes, _modal){
    //this.submissionData.addresses[index] = address.submitted;
    this.foundAddresses.forEach((foundAddress, index) => {
      let addressIndex = -1;
      if(foundAddress.bestMatch && foundAddress.bestMatch.verified === _currentAddressesTypes[index]){
        addressIndex = this.getAddressIndex(foundAddress.bestMatch.addressType);//this.submissionData.addresses.findIndex((address)=>{return address.addressType === foundAddress.bestMatch.addressType});
        this.submissionData.addresses[addressIndex] = foundAddress.bestMatch;
      }else{
        addressIndex = this.getAddressIndex(foundAddress.submitted.addressType);//this.submissionData.addresses.findIndex((address)=>{return address.addressType === foundAddress.submitted.addressType});
        this.submissionData.addresses[addressIndex] = foundAddress.submitted;
      }
      if(this.submissionData.addresses[addressIndex].addressType === this.addressTypeEnum.Business){
        this.submissionBasicInfo.isBusinessAddressVerified = true;
      }else if(this.submissionData.addresses[addressIndex].addressType === this.addressTypeEnum.Mailing){
        this.submissionBasicInfo.isMailingAddressVerified = true;
      }else if(this.submissionData.addresses[addressIndex].addressType === this.addressTypeEnum.Billing){
        this.submissionBasicInfo.isBillingAddressVerified = true;
      }
    });

    if(this.submissionBasicInfo.isExistingAccount == null){
      this.clearAccount(_modal);
    }
    
    this.submissionService.closeModal();
  }

  closeModal(_modal){
    _modal.dismiss('Cross click');
  }

  formatPhoneNumber(str){
    let cleaned = ('' + str).replace(/\D/g, '');
  
    //Check if the input is of correct length
    let match = cleaned.match(/^(\d{3})(\d{3})(\d{4})$/);
  
    if (match) {
      return '(' + match[1] + ')' + match[2] + '-' + match[3]
    };
  }

  clearAccount(_modal){
    let clearAccountRequestPayload = {
      accountName: this.submissionData.accountName,
      accountCity: this.submissionData.addresses[0].city,
      accountPostalCode: this.submissionData.addresses[0].zip,
      accountStateCode: this.submissionData.addresses[0].state,
      producerCode: this.submissionData.producerCode,
      channel: this.channels.Submission,
      thirdPartySource: {
        thirdPartyName: this.submissionData.thirdPartyName,
        thirdPartyKey: this.submissionData.thirdPartyKey,
      }
    };
    this.existingAccountLoading = true;
    let clearAccountSubscription = this.submissionService.clearAccount(clearAccountRequestPayload).subscribe((data:any) => {
      this.existingAccountLoading = false;
      if(_modal){
        _modal.close();
      }
      console.log('_accountResponse :: ', data);
      this.submissionData.accountIndicator = data.accountIndicator;
      this.submissionData.accountKey = data.accounts[0].accountKey;
      if(data.accounts[0].thirdPartySource){ 
        this.submissionData.thirdPartyKey = data.accounts[0].thirdPartySource.thirdPartyKey;
        this.submissionData.thirdPartyName = data.accounts[0].thirdPartySource.thirdPartyName; 
        this.getAddress(this.addressTypeEnum.Business).verified = this.verifyAddressTypesEnum.DNBVERIFIED;
        this.submissionBasicInfo.isBusinessAddressVerified = true;
      }

      /*** 
       * Account Indicators or Statuses Returned
       * 0 - Blocked
       * 1 - New
       * 2 - Duplicate - never gets returned from BE
       * 3 - Duplicate - Open duplicate account modal
       * 4 - Referred to Underwriting
       ***/

      this.submissionBasicInfo.isExistingAccount = (data.accountIndicator === ClearAccountIndicators.DUPLICATE);
      this.accountList = [];

      if(this.submissionBasicInfo.isExistingAccount){
        this.accountList = data.accounts;
        console.log(this.accountList);
        this.submissionService.openModal('none', this.existingAccountModal, false, 'light-blue-backdrop', 'static', 'existing-account-modal');
      }
      else if(!this.submissionBasicInfo.isExistingAccount){
        if(this.submissionData.accountIndicator == 1 && data.accounts[0].thirdPartySource != null){

          /* mapping business details from DNB */
          this.submissionData.accountPhoneNumber = this.formatPhoneNumber(data.accounts[0].accountPhoneNumber);
          this.submissionData.accountWebsite = data.accounts[0].accountWebsite;
          if(data.accounts[0].accountOrganizationType && this.getLegalEntity(data.accounts[0].accountOrganizationType)){this.submissionData.accountLegalEntity = this.getLegalEntity(data.accounts[0].accountOrganizationType);}
          this.submissionData.accountFein = data.accounts[0].accountFEIN;

          /* mapping SIC code(s) from D&B */
          if(data.accounts[0].sics.length>0){
            data.accounts[0].sics.forEach(sic =>{
              if(data.accounts[0].sics.length==1){
                sic.percent = 100;
              }
              this.submissionData.sicCodes.push({
                code: sic.sicCode,
                subClassCode: '0000',
                desc: sic.sicDescription,
                percent: sic.percent
              });
            })
          }
          
          /* mapping NAICS code from D&B */
          if(data.accounts[0].naicsCodes.length==1){
            this.submissionData.naicsCodes.push({
              code: data.accounts[0].naicsCodes[0].naicsCode,
              desc: data.accounts[0].naicsCodes[0].naicsDescription
            });
          }

          /* mapping addresses from D&B */
          data.accounts[0].locations.forEach(address => {
            if(address.accountAddressVerified == this.verifyAddressTypes.DNBVERIFIED){
              let addressData = this.getAddress(address.accountLocationTypeName);
              addressData.addressLine1 = address.accountAddressLine1;
              addressData.verified = address.accountAddressVerified;
              addressData.city = address.accountCity;
              addressData.county = address.accountCountyName;
              addressData.addressType = address.accountLocationTypeName;
              addressData.zip = (address.accountPostalCode.length > 5 && address.accountPostalCode.indexOf('-') === -1) ? address.accountPostalCode.substr(0,5) + '-' + address.accountPostalCode.substr(5, address.accountPostalCode.length - 5) : address.accountPostalCode;
              addressData.state = address.accountStateCode;
              if(address.accountLocationTypeName == this.addressTypeEnum.Business){
                this.submissionBasicInfo.isBusinessAddressVerified = true;
              }
              else if(address.accountLocationTypeName == this.addressTypeEnum.Mailing){
                addressData.addressLine2 = address.accountAddressLine2;
              }
            }
          });

          /* disabling fields where DNB data has been prefilled */
          this.submissionData.accountFeinDisabled = this.checkIfDisabled(this.submissionData.accountFein);
        }

        this.scrollToAccountDetails();
        this.isSubmitted = false;
      }
    },
    error => {
      this.submissionService.loading = false;
      this.existingAccountLoading = false;
      this.submissionService.closeModal();

      if(error.status == StatusCode.InternalServer) {
        setTimeout(() => {
          this.submissionBasicInfo.isBusinessAddressVerified = false;
          this.submissionService.openModal('none', this.clearAccountFailedModal, false, 'light-blue-backdrop', 'static', 'clearAccountFailedModal');
        }, 50);
      }

      console.log("Clear Account Failed");
    });

    this.submissionService.runningServices.push(clearAccountSubscription);
  }
  selectExistingAccount(_account, _location){
    this.submissionData.accountNumber = (!_account.accountNumber || _account.accountNumber === 0) ? null : _account.accountNumber;
    this.submissionData.accountName = _account.accountName;
    this.submissionData.accountDBAName = _account.accountDBAName;

    let tempAccount: any = new BusinessAddress();//this.submissionData.addresses[0];
    tempAccount.addressLine1 = _location.accountAddressLine1;
    tempAccount.addressLine2 = _location.accountAddressLine2;
    tempAccount.city = _location.accountCity;
    tempAccount.state = _location.accountStateCode;
    tempAccount.zip = _location.accountPostalCode;
    tempAccount.county = _location.accountCounty;
    tempAccount.verified =  this.verifyAddressTypesEnum.VERIFIED;

    this.submissionData.addresses[0] = tempAccount;

    this.submissionService.closeModal();

    this.isSubmitted = false;
  }
  closeExistingAccountModal(_modal){
    _modal.close();
    this.submissionBasicInfo.isExistingAccount = null;
  }
  scrollToAccountDetails() {
    window.setTimeout(()=>{
      document.getElementById("basic-info-accountLegalEntity").focus();
      window.setTimeout(()=>{
      (this.newAccountDetails.nativeElement as HTMLElement).scrollIntoView({behavior:"smooth"});
      },100);
    }, 50);
  }

  openBackToSearchModal(){
    this.submissionService.openModal('none', this.backToSearchModal, false, 'light-blue-backdrop', 'static', 'back-to-search-modal', '', false);
  }

  backToSearch(){
    this.submissionBasicInfo = new Submission();
    this.submissionBasicInfo.submissionData.producerCode = this.submissionService.selectedProducer.code;
    this.submissionBasicInfo.submissionData.producerName = this.submissionService.selectedProducer.name;
    this.submissionBasicInfo.submissionData.producerCity = this.submissionService.selectedProducer.producerCity;
    this.submissionBasicInfo.submissionData.producerState = this.submissionService.selectedProducer.producerState;
    this.submissionBasicInfo.submissionData.niche = this.submissionService.selectedNiche.nicheName;
    this.submissionBasicInfo.submissionData.searchState = this.submissionData.searchState;
    this.submissionBasicInfo.selectedStep = SubmissionSteps.BasicInfo;

    this.submissionService.submission = this.submissionBasicInfo;

    this.submissionService.resetSupportingDocuments();

    this.backToBusinessLookup.emit(true);

    this.dnbEventsModel.eventType = DandBEventsTypes.BackToSearch;
    this.dnbEventsModel.choiceIndex = 0;
    this.dnbEventsModel.choice = null;
    this.dnbEventsModel.inCompleteResultCount = 0;
    this.dnbEventsModel.returnResultCount = 0;

    this.submissionService.dnbEventLog(this.dnbEventsModel);

    this.submissionService.closeModal();
  }

  onContinue():boolean{
    this.isSubmitted = true;

    if(this.isCompanyLegalNameInvalid()){
      const formGroupInvalid = this.el.nativeElement.querySelectorAll('#basic-info-accountName');
      if(formGroupInvalid.length > 0){
        (<HTMLInputElement>formGroupInvalid[0]).focus();
        return;
      }
    }
    const formGroupInvalid = this.el.nativeElement.querySelectorAll('.ng-invalid:not(form)');
    if(formGroupInvalid.length>0){
      (<HTMLInputElement>formGroupInvalid[0]).focus();
      return;
    }
    if(this.submissionBasicInfo.isExistingAccount == false && (this.submissionData.sicCodes.length==0 || (this.SICCodePercent() != 100 || this.hasSICCodePercentZero()))){
      document.getElementById('basic-info-sicCodes').focus();
      return;
    }

    if(!this.submissionBasicInfo.isBusinessAddressVerified && !this.submissionData.businessAddressDisabled){
      /** Validate Business Address and clear account */
      this.validateAddress([this.submissionMethod.getBusinessAddress(this.submissionBasicInfo)]);
    }else{
      if(this.submissionBasicInfo.isExistingAccount == true){
        /** Business address is valid and its Existing account. Ready to go to Coverages step.  */
        return (this.basicInfoForm.valid || this.basicInfoForm.disabled);
      }else if(this.submissionBasicInfo.isExistingAccount == false){
        /** Account is cleared and no account found. Its new Account */
        if(!this.submissionBasicInfo.isMailingSameAsInsured && !this.submissionBasicInfo.isMailingAddressVerified || !this.submissionBasicInfo.isBillingSameAsMailing && !this.submissionBasicInfo.isBillingAddressVerified){
          /** Account is cleared and no account found. Its new Account, Validate Mailing and/or Billing Addresses */
          let addresses = [];
          if(!this.submissionBasicInfo.isMailingSameAsInsured && !this.submissionBasicInfo.isMailingAddressVerified){
            addresses.push(this.submissionMethod.getMailingAddress(this.submissionBasicInfo));
          }
          if(!this.submissionBasicInfo.isBillingSameAsMailing && !this.submissionBasicInfo.isBillingAddressVerified){          
            addresses.push(this.submissionMethod.getBillingAddress(this.submissionBasicInfo));
          }
          this.validateAddress(addresses);
        }else{
          /** Business, Mailing and Billing addresses are valid and ready to go to Coverages step.  */
          event.preventDefault();
          if(this.submissionBasicInfo.isMailingSameAsInsured && this.submissionBasicInfo.isBillingSameAsMailing){
            this.submissionData.isMailingOrBillingSameAsInsured = 0; // both are same as insured
          } else if(this.submissionBasicInfo.isMailingSameAsInsured && !this.submissionBasicInfo.isBillingSameAsMailing){
            this.submissionData.isMailingOrBillingSameAsInsured = 1; // mailing same as insured
          } else if(!this.submissionBasicInfo.isMailingSameAsInsured && this.submissionBasicInfo.isBillingSameAsMailing){
            this.submissionData.isMailingOrBillingSameAsInsured = 2; // billing same as mailing
          } else  if(!this.submissionBasicInfo.isMailingSameAsInsured && !this.submissionBasicInfo.isBillingSameAsMailing){
            this.submissionData.isMailingOrBillingSameAsInsured = 3; // both mailing and billing are different
          } else{
            this.submissionData.isMailingOrBillingSameAsInsured = 0; // both are same as insured
          }

          return (this.basicInfoForm.valid && !this.isCompanyLegalNameInvalid() && (this.submissionData.sicCodes.length!=0 && this.SICCodePercent() == 100 && !this.hasSICCodePercentZero()));
        }
      }else{
        this.clearAccount(null);
      }
    }
  }
}
